<div class="container-narrow">
  <div *ngIf="isLoading" style="text-align: center">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <app-header-bar [title]="'Registration'"></app-header-bar>
  <div class="container content-wrap relative p-3 bg-light">
    <div class="row" [hidden]="step != 0">
      <div class="col-md-8 offset-md-2">
        <div class="text-center mt-2 mb-2"></div>

        <h3 class="mt-2 mb-3 sm-title">Account Setup</h3>
        <p>
          If you have been referred on to the i-PREPWELL Programme you will have
          been provided with a unique code which is assigned to your email
          address.
        </p>
        <hr />
        <p>Please enter you email address and registration code below.</p>
        <div class="form-text text-danger" *ngIf="error">
          <p>{{ error }}</p>
        </div>

        <!-- step 1-->
        <form
          #authForm="ngForm"
          class="goal-form"
          (ngSubmit)="onSubmit(authForm)"
        >
          <div class="form-group">
            <label for="email"
              >Email Address: <span class="required">*</span></label
            >
            <input
              type="email"
              id="email"
              class="form-control"
              ngModel
              name="email"
              placeholder="Please enter your email address"
              required
              email
              #email="ngModel"
              [ngClass]="{ 'is-invalid': email.touched && !email.valid }"
              autocomplete="off"
            />
            <div
              class="form-text text-danger"
              *ngIf="!email.valid && email.touched"
            >
              Your email is invalid
            </div>
          </div>
          <hr />
          <div class="form-group">
            <label for="code"
              >Registration Code: <span class="required">*</span></label
            >
            <input
              type="text"
              id="code"
              class="form-control"
              ngModel
              name="code"
              placeholder="Please enter your Registration Code"
              required
              autocomplete="off"
              #code="ngModel"
              [ngClass]="{ 'is-invalid': code.touched && !code.valid }"
            />
            <div
              class="form-text text-danger"
              *ngIf="!code.valid && code.touched"
            >
              Your code is invalid
            </div>
          </div>

          <hr />
          <div class="required-info">
            <span class="required">*</span> Required field
          </div>

          <button
            type="submit"
            [disabled]="!authForm.valid || isLoading"
            class="btn btn-primary w-100"
          >
            Start Registration
            <span class="icon-wrap">
              <fa-icon
                [icon]="['far', 'arrow-circle-right']"
                [fixedWidth]="true"
              ></fa-icon>
            </span>
          </button>
        </form>
        <hr />
        <span
          >Already have an account?
          <a [routerLink]="['/login']">Sign in now</a></span
        >
      </div>
    </div>
    <form
      #detailsForm="ngForm"
      class="goal-form"
      (ngSubmit)="onSubmitRegistration(detailsForm)"
    >
      <div class="row" [hidden]="step != 1">
        <div class="col-md-8 offset-md-2">
          <fieldset ngModelGroup="accountSetup" #accountSetup="ngModelGroup">
            <div class="text-center mt-2 mb-2">
              <div class="badge bg-dark">Step 1</div>
            </div>

            <h3 class="mt-2 mb-3 sm-title">Account Setup</h3>
            <div class="form-text text-danger" *ngIf="error">
              <p>{{ error }}</p>
            </div>

            <div class="text-center">
              <div>{{ user?.email }}</div>
              <div>Registration Code: {{ user?.code }}</div>
            </div>
            <hr />
            <div
              ngModelGroup="passwords"
              #passwords="ngModelGroup"
              appCheckPassword
            >
              <div class="form-group">
                <label for="password"
                  >Set Password: <span class="required">*</span></label
                >
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  name="password"
                  placeholder="Please enter your password"
                  required
                  pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{9,}"
                  [ngClass]="{
                    'is-invalid': password.dirty && !password.valid
                  }"
                  #password="ngModel"
                  [(ngModel)]="password1"
                />
                <hr />
                <label for="passwordConfirm"
                  >Confirm Password: <span class="required">*</span></label
                >
                <input
                  type="password"
                  id="passwordConfirm"
                  class="form-control"
                  name="passwordConfirm"
                  placeholder="Please confirm your password"
                  required
                  [ngClass]="{
                    'is-invalid':
                      passwordConfirm.dirty && !passwordConfirm.valid
                  }"
                  #passwordConfirm="ngModel"
                  [(ngModel)]="password2"
                />

                <div
                  *ngIf="
                    passwords.errors?.passwordCheck &&
                    (passwordConfirm.dirty || passwordConfirm.touched)
                  "
                  class="form-text text-danger"
                >
                  Passwords do not match.
                </div>
                <hr />
                <p>Your password must contain the following</p>
                <ul>
                  <li
                    [ngClass]="{
                      'text-danger':
                        password.dirty && password.viewModel.length < 10,
                      'text-success':
                        password.dirty && password.viewModel.length > 9
                    }"
                  >
                    At least 10 characters
                    <span
                      class="icon-wrap"
                      *ngIf="password.viewModel.length > 9"
                      ><fa-icon
                        [icon]="['far', 'check']"
                        [fixedWidth]="true"
                      ></fa-icon></span
                    ><span
                      class="icon-wrap"
                      *ngIf="password.dirty && password.viewModel.length < 10"
                      ><fa-icon
                        [icon]="['far', 'times']"
                        [fixedWidth]="true"
                      ></fa-icon
                    ></span>
                  </li>
                  <li
                    [ngClass]="{
                      'text-danger':
                        password.dirty &&
                        !checkPassword(password.viewModel, 'upper'),
                      'text-success':
                        password.dirty &&
                        checkPassword(password.viewModel, 'upper')
                    }"
                  >
                    An uppercase character (A-Z)
                    <span
                      class="icon-wrap"
                      *ngIf="checkPassword(password.viewModel, 'upper')"
                      ><fa-icon
                        [icon]="['far', 'check']"
                        [fixedWidth]="true"
                      ></fa-icon></span
                    ><span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        !checkPassword(password.viewModel, 'upper')
                      "
                      ><fa-icon
                        [icon]="['far', 'times']"
                        [fixedWidth]="true"
                      ></fa-icon
                    ></span>
                  </li>
                  <li
                    [ngClass]="{
                      'text-danger':
                        password.dirty &&
                        !checkPassword(password.viewModel, 'lower'),
                      'text-success':
                        password.dirty &&
                        checkPassword(password.viewModel, 'lower')
                    }"
                  >
                    A lowercase character (a-z)
                    <span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        checkPassword(password.viewModel, 'lower')
                      "
                      ><fa-icon
                        [icon]="['far', 'check']"
                        [fixedWidth]="true"
                      ></fa-icon></span
                    ><span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        !checkPassword(password.viewModel, 'lower')
                      "
                      ><fa-icon
                        [icon]="['far', 'times']"
                        [fixedWidth]="true"
                      ></fa-icon
                    ></span>
                  </li>
                  <li
                    [ngClass]="{
                      'text-danger':
                        password.dirty &&
                        !checkPassword(password.viewModel, 'num'),
                      'text-success':
                        password.dirty &&
                        checkPassword(password.viewModel, 'num')
                    }"
                  >
                    A digit (0-9)<span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        checkPassword(password.viewModel, 'num')
                      "
                      ><fa-icon
                        [icon]="['far', 'check']"
                        [fixedWidth]="true"
                      ></fa-icon></span
                    ><span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        !checkPassword(password.viewModel, 'num')
                      "
                      ><fa-icon
                        [icon]="['far', 'times']"
                        [fixedWidth]="true"
                      ></fa-icon
                    ></span>
                  </li>
                  <li
                    [ngClass]="{
                      'text-danger':
                        password.dirty &&
                        !checkPassword(password.viewModel, 'special'),
                      'text-success':
                        password.dirty &&
                        checkPassword(password.viewModel, 'special')
                    }"
                  >
                    A special character ($@!%*?)<span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        checkPassword(password.viewModel, 'special')
                      "
                      ><fa-icon
                        [icon]="['far', 'check']"
                        [fixedWidth]="true"
                      ></fa-icon></span
                    ><span
                      class="icon-wrap"
                      *ngIf="
                        password.dirty &&
                        !checkPassword(password.viewModel, 'special')
                      "
                      ><fa-icon
                        [icon]="['far', 'times']"
                        [fixedWidth]="true"
                      ></fa-icon
                    ></span>
                  </li>
                </ul>
                <div
                  class="form-text text-danger"
                  *ngIf="!password.valid && password.touched"
                >
                  Your password is invalid
                </div>
              </div>
            </div>
            <hr />

            <div class="form-group">
              <label for="agreeTerms">
                Agree to the Terms and Conditions
                <span class="required">*</span>
              </label>
              <div class="form-check">
                <input
                  type="checkbox"
                  name="isAccept"
                  ngModel
                  id="agreeTerms"
                  required
                  class="form-check-input"
                />
                Please review and accept
                <a class="pointer" [routerLink]="['./']"
                  >Terms &amp; Conditions</a
                >
              </div>
            </div>

            <hr />
            <div class="required-info">
              <span class="required">*</span> Required field
            </div>

            <button
              type="button"
              [disabled]="!accountSetup.valid || isLoading"
              class="btn btn-primary w-100"
              (click)="onNext($event)"
            >
              Next
              <span class="icon-wrap">
                <fa-icon
                  [icon]="['far', 'arrow-circle-right']"
                  [fixedWidth]="true"
                ></fa-icon>
              </span>
            </button>
          </fieldset>
        </div>
      </div>
      <!-- user details -->

      <div class="row" [hidden]="step != 2">
        <div class="col-md-8 offset-md-2">
          <fieldset
            ngModelGroup="personalDetails"
            #personalDetails="ngModelGroup"
          >
            <div class="text-center mt-2 mb-2">
              <div class="badge bg-dark">Step 2</div>
            </div>

            <h3 class="mt-2 mb-3 sm-title">Personal details</h3>
            <div class="form-text text-danger" *ngIf="error">
              <p>{{ error }}</p>
            </div>

            <div class="form-group">
              <label for="firstName"
                >First name: <span class="required">*</span></label
              >
              <input
                type="text"
                id="firstName"
                class="form-control"
                ngModel
                name="firstName"
                placeholder="Please enter your first name"
                required
                [ngModel]="user?.first_name"
                #firstName="ngModel"
                [ngClass]="{
                  'is-invalid': firstName.touched && !firstName.valid
                }"
              />
            </div>
            <hr />
            <div class="form-group">
              <label for="lastName"
                >Last name: <span class="required">*</span></label
              >
              <input
                type="text"
                id="lastName"
                class="form-control"
                ngModel
                name="lastName"
                placeholder="Please enter your last name"
                required
                [ngModel]="user?.last_name"
                #lastName="ngModel"
                [ngClass]="{
                  'is-invalid': firstName.touched && !firstName.valid
                }"
              />
            </div>
            <hr />
            <div class="form-group">
              <label for="username"
                >Username: <span class="required">*</span></label
              >
              <input
                type="text"
                id="username"
                class="form-control"
                ngModel
                name="username"
                placeholder="Please enter your username"
                required
                [ngModel]="user?.username"
                #username="ngModel"
                [ngClass]="{
                  'is-invalid': username.touched && !username.valid
                }"
                asyncUsernameValidator
              />
              <div
                *ngIf="username.touched && !username.valid"
                class="form-text text-danger"
              >
                This Username is unavailable
              </div>
              <div class="instructions mt-3 mb-1">
                This will be used if you post in the forum and can be seen by
                other patients. Please use numbers and letters only with no
                spaces.
              </div>
            </div>
            <hr />

            <div class="form-group">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="smoke"
                  name="smoke"
                  [ngModel]="user.smoke"
                  #smoke="ngModel"
                  value="1"
                />
                <label class="form-check-label" for="smoke"
                  >Do you smoke?</label
                >
              </div>
            </div>
            <hr />

            <div class="form-group">
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="drink"
                  name="drink"
                  [ngModel]="user.drink"
                  #drink="ngModel"
                  value="1"
                />
                <label class="form-check-label" for="drink"
                  >Do you drink alcohol?</label
                >
              </div>
            </div>
            <hr />

            <div class="required-info">
              <span class="required">*</span> Required field
            </div>

            <div class="row">
              <div class="col">
                <button
                  type="button"
                  [disabled]="isLoading"
                  class="btn btn-menu-bg w-100"
                  (click)="onPrev($event)"
                >
                  <span class="icon-wrap">
                    <fa-icon
                      [icon]="['far', 'arrow-circle-left']"
                      [fixedWidth]="true"
                    ></fa-icon>
                  </span>
                  Previous
                </button>
              </div>
              <div class="col">
                <button
                  type="button"
                  [disabled]="!personalDetails.valid || isLoading"
                  class="btn btn-primary w-100"
                  (click)="onNext($event)"
                >
                  Next
                  <span class="icon-wrap">
                    <fa-icon
                      [icon]="['far', 'arrow-circle-right']"
                      [fixedWidth]="true"
                    ></fa-icon>
                  </span>
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div class="row" [hidden]="step != 3">
        <div class="col-md-8 offset-md-2">
          <fieldset
            ngModelGroup="surgeryDetails"
            #surgeryDetails="ngModelGroup"
          >
            <div class="text-center mt-2 mb-2">
              <div class="badge bg-dark">Step 3</div>
            </div>

            <h3 class="mt-2 mb-3 sm-title">Surgery details</h3>
            <div class="form-text text-danger" *ngIf="error">
              <p>{{ error }}</p>
            </div>

            <div class="form-group">
              <label for="surgery_date">Surgery Date</label>

              <input
                type="text"
                id="surgery_date"
                class="form-control"
                [ngModel]="bsDate"
                #surgery_date="ngModel"
                name="surgery_date"
                placeholder="DD/MM/YYYY"
                date
                bsDatepicker
                autocomplete="off"
                [maxDate]="maxDate"
                [bsConfig]="{
                  dateInputFormat: 'DD/MM/YYYY',
                  containerClass: 'theme-prepwell',
                  showWeekNumbers: false
                }"
              />
              <div
                class="form-text text-danger"
                *ngIf="!surgery_date.valid && surgery_date.touched"
              >
                Please enter a date above
              </div>
            </div>
            <hr />
            <div class="form-group form-floating">
              <select
                ngModel
                class="form-select"
                name="op_area_id"
                id="opArea"
                #op_area_id="ngModel"
                [ngModel]="user?.op_area_id"
                [ngClass]="{
                  'is-invalid': op_area_id.touched && !op_area_id.valid
                }"
              >
                <option disabled value>Please Select...</option>
                <option
                  *ngFor="let opArea of regData?.opAreas; trackBy: trackByIndex"
                  [value]="opArea.value"
                >
                  {{ opArea.label }}
                </option>
              </select>
              <label for="opAreas">Operation:</label>
            </div>

            <hr />

            <div class="required-info">
              <span class="required">*</span> Required field
            </div>

            <div class="row">
              <div class="col">
                <button
                  type="button"
                  [disabled]="isLoading"
                  class="btn btn-menu-bg w-100"
                  (click)="onPrev($event)"
                >
                  <span class="icon-wrap">
                    <fa-icon
                      [icon]="['far', 'arrow-circle-left']"
                      [fixedWidth]="true"
                    ></fa-icon>
                  </span>
                  Previous
                </button>
              </div>
              <div class="col">
                <button
                  type="submit"
                  [disabled]="!personalDetails.valid || isLoading"
                  class="btn btn-primary w-100"
                >
                  Complete
                  <span class="icon-wrap">
                    <fa-icon
                      [icon]="['far', 'arrow-circle-right']"
                      [fixedWidth]="true"
                    ></fa-icon>
                  </span>
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </form>
    <!-- end user details -->
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Terms and Conditions</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- terms?? -->
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef?.hide()">
      Close
    </button>
  </div>
</ng-template>
